// extracted by mini-css-extract-plugin
export default {"action":"Thread_action__xkZNo","action___delete":"Thread_action___delete__ASHhc"};